import { useCallback, useEffect, useState } from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { ReportCompanyOutletContext, REPORT_SCOPE_CLIENT_STATE_KEY } from '../context/ReportCompanyOutletContext'
import { ReportCompanyIdentifier } from './ReportCompanyIdentifier'

export function ReportScopeLayout() {
    const { reportId } = useParams()
    const location = useLocation()
    const [companyName, setCompanyName] = useState(null)
    const [companyCnpj, setCompanyCnpj] = useState(null)

    useEffect(() => {
        setCompanyName(null)
        setCompanyCnpj(null)
    }, [reportId])

    useEffect(() => {
        const fromList = location.state?.[REPORT_SCOPE_CLIENT_STATE_KEY]
        if (fromList && (fromList.name != null || fromList.cnpj != null)) {
            setCompanyName(fromList.name ?? null)
            setCompanyCnpj(fromList.cnpj ?? null)
        }
    }, [location.key, location.state])

    const applyClient = useCallback(client => {
        if (!client) return
        setCompanyName(client.name ?? null)
        setCompanyCnpj(client.cnpj ?? null)
    }, [])

    return (
        <ReportCompanyOutletContext.Provider value={applyClient}>
            <ReportCompanyIdentifier companyName={companyName} companyCnpj={companyCnpj} />
            <Outlet />
        </ReportCompanyOutletContext.Provider>
    )
}
